import React, { useEffect, useState } from "react"
import { QuadriRestApi, TaskType, TaskTypeProperty } from "../../api/QuadriRestApi"
import ConnectApi from "../../api/ConnectApi"
import "./PublishedTaskPreview.css"
import GetEnvironment from "../../environments"

interface PublishedTaskPreviewProps {
  projectId: string
  projectOrigin: string
  quadriProjectId: string
  taskId: number
}

export const PublishedTaskPreview: React.FC<PublishedTaskPreviewProps> = ({
  projectId,
  projectOrigin,
  quadriProjectId,
  taskId
}) => {
  const [fileId, setFileId] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [thumbnailUrl, setThumbnailUrl] = useState<string | null>(null)

  const resetState = () => {
    setLoading(true)
    setError(null)
    setFileId(null)
    setThumbnailUrl(null)
  }

  useEffect(() => {
    if (!projectId || !taskId || !quadriProjectId) return
    resetState()

    const fetchTask = async () => {
      try {
        const restApi = new QuadriRestApi()
        await restApi.initialize()
        const taskType = await restApi.getTask(projectId, QuadriRestApi.encodeTaskId(quadriProjectId, String(taskId)))

        if (!taskType) return

        const trimbimFileGuid = taskType.details?.properties?.find(
          (property: TaskTypeProperty) => property.definition?.name === "FILE_GUID"
        )

        if (trimbimFileGuid) setFileId(trimbimFileGuid.value)
      } catch (err: any) {
        setError(err.message)
      } finally {
        setLoading(false)
      }
    }

    fetchTask()
  }, [projectId, taskId, quadriProjectId])

  useEffect(() => {
    if (!fileId || !projectOrigin) return
    setThumbnailUrl(null)
    const fetchThumbnailUrl = async () => {
      try {
        const api = new ConnectApi(projectOrigin)
        const file = await api.getConnectFile(fileId)
        if (file) setThumbnailUrl(file.thumbnailUrl)
      } catch (err: any) {
        setError(err.message)
      }
    }
    fetchThumbnailUrl()
  }, [fileId, projectOrigin])

  //Do we want to show a loading state?
  if (loading) {
    return null
  }

  //Do we want to show an error state?
  if (error) {
    return <div style={{ color: "red" }}>{error}</div>
  }
  // Return nothing if fileId is not set
  if (!fileId) return null

  return (
    <div>
      {thumbnailUrl && (
        <div className="published-task-thumbnail-container">
          <img src={thumbnailUrl} alt="Task thumbnail" className="published-task-thumbnail-img" />
        </div>
      )}
      <hr style={{ margin: "0 0 16px 0" }} />
      <div style={{ textAlign: "left" }}>
        <a
          className="button secondary mr-1 no-underline text-ellipsis published-task-view-btn"
          href={`${GetEnvironment().connectWebUrl}/projects/${projectId}/detailviewer?fileId=${fileId}`}
          aria-label="View in detail viewer"
          title="View in detail viewer"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="text-ellipsis">View</span>
        </a>
      </div>
      <hr style={{ margin: "16px 0" }} />
    </div>
  )
}
